import React, { ReactElement } from "react";

let Styles: any;

try {
  Styles = require('./Table_' + process.env.REACT_APP_CODE_TENANT + '.module.scss');
}
catch{
}

interface DynamicTableProps {
  dataHeader: string[],
  headerTitle?: ReactElement,
  children : ReactElement
}

const DynamicTable: React.FC<DynamicTableProps> = (props: DynamicTableProps) => {

    const { dataHeader, children, headerTitle} = props;
    const header = dataHeader.map((item) => (
      <td className ={Styles.header}>{item}</td>
    ));

  return (
    <div className="table-responsive">
      <table className={Styles.customColorTable  + " table "}>
          <thead>
            <tr>{headerTitle}</tr>
            <tr>{header}</tr>
          </thead>
          <tbody>
            {children}
          </tbody>
      </table>
    </div>
    );
};

export default DynamicTable;

